<template>
  <div class="unusual-page">
    <section class="content-box">
      <img src="../../assets/images/bg_wuyemian.png" alt="">
      <div class="detail">
        <h3>404！</h3>
        <p>抱歉，你访问的页面不存在</p>
        <a-button type="primary" @click="backToLogin">返回登录页</a-button>
      </div>
    </section>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'noPage',
  data () {
    return {};
  },
  methods: {
    backToLogin () {
      empty.$emit('setCacheData');
    }
  }
};

</script>
